<template>
  <div class="d-search-tags grid-flex grid-no-response border-bottom space-bottom-3em">
    <div class="grid-item">
      <DuiLabelGroup
        :allow-removal="true"
        color="sand"
        size="sm"
        :store-load-key="`${ storeSearchPrefix }/get-displayed-search-tags`"
        :store-update-key="`${ storeSearchPrefix }/removeSearchTag`"
      />
    </div>

    <div class="grid-item-shrink text-right">
      <a
        class="no-decoration"
        @click="clearTags"
      >
        <span class="hidden-until-md">Clear filters</span>
        <span class="button-icon button-sm button-grey button-close space-left-1em" />
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      storeSearchPrefix: {
        type: String,
        required: true,
      },
    },
    methods: {
      clearTags() {
        this.$store.dispatch(`${ this.storeSearchPrefix }/clearSearchTags`);
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-search-tags {
  .dui-label-group {
    margin-bottom: $_1em;

    @include screenMoreThan(sm) {
      margin-right: $_1em;
    }
  }
}
</style>
